module.exports=function(scope){ return `{
   "success": true,
   "license": "# FaceTec mobile SDK Key appId = * expiryDate = <THIS_WILL_BE_A_DYNAMIC_EXPIRATION_DATE> key = <THIS_WILL_BE_A_DYNAMIC_SIGNED_VALUE>"
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/wildcard-licenses/response/licensing.json.tpl